
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BreadcrumbsModule } from "src/app/components/elementi-strutturali/breadcrumbs/breadcrumbs.module";
import { ActionsListComponent } from "src/app/shared/components/actions-list/actions-list.component";
import { SocialShareComponent } from "src/app/shared/components/social-share/social-share.component";
import { SharedModuleModule } from "src/app/shared/shared-module/shared-module.module";
import { NewsLayoutComponent } from "./news-layout.component";

@NgModule({
  imports: [CommonModule, BreadcrumbsModule, SharedModuleModule, SocialShareComponent, ActionsListComponent],
  declarations: [NewsLayoutComponent],
  exports: [NewsLayoutComponent],

})
export class NewsLayoutModule {
  static component = NewsLayoutComponent
}